module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_presentation_x32-77a9d.png";